import * as React from "react";
import moment from "moment";
import {
    Col,
    Row,
    Button,
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter
} from "reactstrap";
import { Dropdown } from "primereact/dropdown";
import { InputText } from "primereact/inputtext";
import { useAuth0 } from "../auth/react-auth0-wrapper";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { getFromPlate, getPlateAnagrafica } from "../api/vehicles";

const VehiclePlateEdit = ({ vehicle, errors, onChange }) => {
    const { domains } = useAuth0();
    const [loading, setLoading] = React.useState(false);
    const [opened, setOpened] = React.useState(false);

    const [plateData, setPlateData] = React.useState();
    const [selection, setSelection] = React.useState();

    const onVehicleChange = changedProps => {
        const newVehicle = { ...vehicle, ...changedProps };
        onChange({
            value: newVehicle
        });
    };

    const getDDTextInEvent = e =>
        e.originalEvent && e.originalEvent.currentTarget
            ? e.originalEvent.currentTarget.innerText
            : e.value;

    const onAttributesChange = changedProps => {
        const attributes = { ...(vehicle.attributes || {}), ...changedProps };
        const newVehicle = { ...vehicle, attributes };

        onChange({
            value: newVehicle
        });
    };

    const searchPlate = async () => {
        if (!vehicle.plate || vehicle.plate.length < 5) return;
        try {
            setLoading(true);
            const result = await getFromPlate(vehicle.plate);
            setPlateData(result);
            setOpened(true);
        } catch (error) {
            console.log(error);
        } finally {
            setLoading(false);
        }
    };

    const selectCarAnag = async e => {
        setSelection(e.value);
        try {
            setLoading(true);
            const result = await getPlateAnagrafica(e.value.CodiceInfocarAM);
            const newVehicle = {
                ...vehicle,
                plate: vehicle.plate,
                registration: vehicle.plate,
                km: vehicle.km,
                registeredat: moment(plateData.Dataimmatricolazione),
                attributes: {
                    ...(vehicle.attributes || {}),
                    frame: plateData.Telaio,
                    preparation: result.DescrizioneCompleta,
                    model: result.DescrizioneModello,
                    make: result.DescrizioneMarca,
                    infocarMake: result.CodiceMarca,
                    infocarModel: result.CodiceModello,
                    fromPlate: true
                }
            };
            onChange({
                value: newVehicle
            });
            setOpened(false);
        } catch (error) {
            console.log(error);
        } finally {
            setLoading(false);
        }
    };

    const vehicleSelector = () => {
        if (!plateData) return;
        return (
            <Modal isOpen={opened} centered backdrop={true}>
                <ModalHeader toggle={() => setOpened(false)}>
                    {`Targa ${vehicle.plate} Telaio ${plateData.Telaio} Data Immatricolazione ${moment(plateData.Dataimmatricolazione).format("DD/MM/YYYY")}`}
                </ModalHeader>
                <ModalBody>
                    <DataTable
                        value={plateData ? plateData.Lista : []}
                        loading={loading}
                        selectionMode="single"
                        selection={selection}
                        onSelectionChange={selectCarAnag}
                        className="p-datatable-hoverable-rows p-datatable-customers"
                        emptyMessage={() => (<div className="text-center">Nessun dato in tabella</div>)}
                    >
                        <Column
                            field="DescrizioneCompleta"
                            header="Seleziona un allestimento"
                        />
                    </DataTable>
                </ModalBody>
                <ModalFooter>
                    <div className="float-right mt-5">
                        <Button color="warning" onClick={() => setOpened(false)}>
                            <i className="pi pi-times"></i> Annulla
                        </Button>
                    </div>
                </ModalFooter>
            </Modal>
        );
    };

    const attributes = vehicle.attributes || {};
    const attributesErrors = errors.agttributes || {};
    const { plate, registeredat, km } = vehicle;

    const updateKm = async km => {
        if (!vehicle.km || vehicle.km.length < 3) return;
        try {
            setLoading(true);
            //const result = await getFromPlate(vehicle.plate);
            //setPlateData(result);
            //setOpened(true);
        } catch (error) {
            console.log(error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <Row>
            <Col sm="6" xs="12">
                <strong className="mt-2">Tipo Veicolo</strong>
                <Dropdown
                    filter
                    filterBy="label"
                    id="vehicleType"
                    className={attributesErrors.type ? "p-error" : ""}
                    value={attributes.type || ""}
                    showClear={true}
                    style={{ width: "100%" }}
                    options={domains.vehicleTypes}
                    onChange={e => {
                        onAttributesChange({
                            type: e.value
                        });
                    }}
                />
            </Col>
            <Col sm="6" xs="12">
                <strong className="mt-2">Alimentazione</strong>
                <Dropdown
                    filter
                    filterBy="label"
                    id="codSupplier"
                    className={attributesErrors.infocarSupplier ? "p-error" : ""}
                    value={attributes.infocarSupplier || ""}
                    showClear={true}
                    style={{ width: "100%" }}
                    options={domains.alimentazione.filter(el => el.value !== "0")}
                    onChange={e => {
                        onAttributesChange({
                            infocarSupplier: e.value,
                            supplier: getDDTextInEvent(e)
                        });
                    }}
                />
            </Col>
            <Col sm="6" xs="12">
                <div><strong className="mt-2">Targa</strong></div>
                <InputText
                    className={`mr-2 ${errors.plate ? "p-error" : ""}`}
                    value={plate || ""}
                    style={{ width: "60%" }}
                    onChange={e => onVehicleChange({ plate: e.target.value })}
                />
                <Button
                    disabled={loading ? true : false}
                    color="info"
                    onClick={searchPlate}
                >
                    <FontAwesomeIcon
                        icon={loading ? "circle-notch" : "search"}
                        spin={loading}
                    />{" "}
                    Cerca
                </Button>
            </Col>
            <Col sm="6" xs="12">
                <div><strong className="mt-2">Km</strong></div>
                <InputText
                    className={`mr-2 ${errors.km ? "p-error" : ""}`}
                    value={km || ""}
                    style={{ width: "60%" }}
                    keyfilter="pint"
                    onChange={e => onVehicleChange({ km: e.target.value })}
                />
                <Button
                    disabled={loading ? true : false}
                    color="info"
                    onClick={e => updateKm({ km: e.target.value })}
                >
                    <FontAwesomeIcon
                        icon={loading ? "circle-notch" : "tachometer-alt"}
                        spin={loading}
                    />{" "}
                    Aggiorna Km
                </Button>
            </Col>

            {attributes.frame && (
                <React.Fragment>
                    <Col sm="6" xs="12">
                        <strong className="mt-2">Numero di telaio</strong>
                        <InputText
                            readOnly
                            value={attributes.frame || ""}
                            style={{ width: "100%" }}
                        />
                    </Col>
                    <Col sm="6" xs="12">
                        <strong className="mt-2">Data immatricolazione</strong>
                        <InputText
                            readOnly
                            value={
                                registeredat
                                    ? moment(vehicle.registeredat).format("DD/MM/YYYY")
                                    : ""
                            }
                            style={{ width: "100%" }}
                        />
                    </Col>
                    <Col sm="12" xs="12">
                        <strong className="mt-2">Marca/Modello/Allestimento</strong>
                        <InputText
                            readOnly
                            value={attributes.preparation || ""}
                            style={{ width: "100%" }}
                        />
                    </Col>
                    <Col sm="6" xs="6">
                        <strong className="mt-2">Codice linea CAN</strong>
                        <InputText
                            className={attributesErrors.canCode ? "p-error" : ""}
                            value={attributes.canCode || ""}
                            style={{ width: "100%" }}
                            onChange={e => onAttributesChange({ canCode: e.target.value })}
                        />
                    </Col>
                    <Col sm="12" xs="12">
                        <strong className="mt-2">Note</strong>
                        <InputText
                            className={attributesErrors.note ? "p-error" : ""}
                            value={attributes.note || ""}
                            style={{ width: "100%" }}
                            onChange={e => onAttributesChange({ note: e.target.value })}
                        />
                    </Col>
                </React.Fragment>
            )}
            {vehicleSelector()}
        </Row>
    );
};

export default VehiclePlateEdit;
